import { render, staticRenderFns } from "./ProviderDash.vue?vue&type=template&id=5b93fa65&scoped=true&"
import script from "./ProviderDash.vue?vue&type=script&lang=js&"
export * from "./ProviderDash.vue?vue&type=script&lang=js&"
import style0 from "./ProviderDash.vue?vue&type=style&index=0&id=5b93fa65&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b93fa65",
  null
  
)

export default component.exports